import AppPersonContext from './AppPersonContext'
import contextConnector from 'helpers/contextConnectorV2'

export default contextConnector(AppPersonContext)
